import { TEXTS } from '../../constants';
import { textsApi } from '../../state/query/texts';
import store from '../../state/store';
import ENVIRONMENT_VARIABLES from '../environmentVariables';
export var getText = function getText(key) {
  //const { data } = textsApi.endpoints.getTexts.select({ lang: ENVIRONMENT_VARIABLES.LANGUAGE })(store.getState());
  return TEXTS[key];
  /* (data && data[key]) || */
};